
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".7","x":".5","y":".5","width":"29","height":"29","rx":"4.5","stroke":"#C7C7C7"}}),_c('path',{attrs:{"d":"M25.354 15.354a.5.5 0 000-.708l-3.182-3.182a.5.5 0 10-.707.708L24.293 15l-2.828 2.828a.5.5 0 10.707.707l3.182-3.181zM5 15.5h20v-1H5v1z","fill":"#6E88F3"}})])
          )
        }
      }
    